import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl = '';
}

/**
 * Parameters for `GeneratedApiModule.forRoot()`
 */
export interface ApiConfigurationParams {
  rootUrl?: string;
}
